export default {
  avatar: 'Avatar',
  left: {
    fans: '粉丝',
    follow: '关注',
    personal_center: '个人中心',
    my_order: '我的订单',
    my_exhibition: '我的展会',
    my_vote: '我的门票',
    my_visa: '我的签证',
    my_hotel: '我的酒店',
    my_planeTicket: '我的机票',
    exhibitor_list: '展商名录',
    exhibitions_followed: '关注的展会',
    authentication: '企业认证',
    change_password: '修改密码'
  },
  right: {
    // 个人中心
    follow_industry: '关注的行业',
    add_button: '添加',
    recent: '近期展会',
    distance: '距离开展',
    day: '天',
    ln_progress: '开展中...',
    time_updating: '时间更新中......',
    modify_info: '修改个人资料',
    head_sculpture: '头像',
    prompt: '点击图片替换头像',
    user_name: '用户名',
    user_placeholder: '请输入用户名(必填)',
    gender: '性别',
    gender_placeholder: '请选择性别(必选)',
    male: '男',
    female: '女',
    corporate_name: '公司名称',
    corporate_plader: '请输入公司名称(必填)',
    main_products: '主营产品',
    main_placeholder: '请输入公司产品(必填)',
    company_website: '公司网址',
    company_plader: '请输入公司名称(选填)',
    duties: '职务',
    duties_plader: '请输入职务(必填)',
    email: '邮箱',
    email_plader: '请输入邮箱(选填)',
    confirm_button: '确认',
    modifyInfo_inputRule1: '请输入用户名.',
    modifyInfo_inputRule2: '请选择性别.',
    modifyInfo_inputRule3: '昵称不能是手机号、电话号、邮箱或包含特殊字符',
    modifyInfo_inputRule4: '请输入公司名称.',
    modifyInfo_inputRule5: '请输入公司产品',
    modifyInfo_inputRule6: '请输入职位.',
    // 我的展会
    applied_for: '我申请过的展会',
    participate: '参展公司',
    exhibit_content: '展品内容',
    booth_type: '展位类型',
    booth_area: '展位面积',
    processed: '已处理',
    pending: '待处理',
    raw_sace: '光地展位',
    standard_booth: '标准展位',
    advanced_booth: '进阶展位',
    // 我的门票
    my_vote: '我的门票',
    whole: '全部',
    tobepaid: '待支付',
    issue_tickets: '出票中',
    stop_tickets: '已出票',
    refunded: '已退款',
    // 我的签证
    my_visa: '我的签证',
    // 我的酒店
    my_hotel: '我的酒店',
    // 我的机票
    my_plane_ticket: '我的机票',
    closed: '已关闭',
    // 展商名录
    order_num: '订单编号',
    create_time: '创建时间',
    electronic_journal: 'Exhibitor',
    ear_of_publication: '会刊年份',
    journal_name: '会刊名称',
    notes1:
      '备注：展商名录/电子会刊将在1-2个工作日内以电子邮件形式发送至申请人邮箱，请注意查收(如未收到请查看垃圾邮箱或联系0571-88560061)',
    notes2: '在线展商名录仅支持浏览，不发邮件，不支持复制文字等内容',
    refer_to_button: '查阅会刊',
    state_button1: '开发票',
    state_button2: '开发票中',
    state_button3: '查看发票',
    order_status1: '未支付',
    order_status2: '已申请',
    order_status3: '已支付',
    order_status4: '已完成',
    // 关注的展会
    correct_follow: '已关注',
    deny_follow: '关注',
    follow_exhibition: '关注展会',
    industry_follow: '关注行业',
    launch_time: '还有',
    launch_time_day: '天',
    open_develop: '开展中',
    nextterm_time_renew: '下届时间更新中',
    view_details: '查看详情',
    other_user_box1: '其他一些推荐',
    other_user_box2: '的用户',
    recommend_exhibition: '推荐展会',
    ETag_status1: '普通',
    ETag_status2: '时间变更',
    ETag_status3: '变更',
    ETag_status4: '取消',
    // 企业认证
    account_login: '账号登录:',
    auth_corporate: '公司名称:',
    your_corporate: '您的公司名称',
    english_name: '英文名称',
    your_english_name: '您的公司英文名称',
    corporate_address: '公司地址:',
    select_address: '请选择地址',
    indetail_address: '详细地址:',
    where_address: '所在公司地址',
    corporate_introduce: '公司介绍:',
    introduce: '介绍',
    corporate_phone: '公司电话',
    registered_capital: '注册资金:',
    select_capital: '请选择企业注册资金',
    capital_option1: '100万以下',
    capital_option2: '100-500万',
    capital_option3: '500万-1000万',
    capital_option4: '1000万-3000万',
    capital_option5: '3000万以上',
    staff_num: '员工人数:',
    select_staff_num: '请选择员工人数',
    staff_num_option1: '10-30人',
    staff_num_option2: '30-50人',
    staff_num_option3: '50-100人',
    staff_num_option4: '100人以上',
    service_area: '服务区域:',
    delete: '删除',
    contacts: '联系人:',
    Enter_contacts: '请输入联系人',
    mobile_phone: '手机号:',
    Enter_phone: '请输入手机号',
    Enter_qq: '请输入qq',
    WeChat: '微信:',
    Enter_WeChat: '请输入微信',
    mailbox: '邮箱:',
    Enter_mailbox: '请输入邮箱',
    position: '职位:',
    Enter_position: '请选择职位',
    position_option1: '普通员工',
    position_option2: '经理',
    position_option3: '总经理',
    position_option4: '董事长',
    id_card: '身份证:',
    business_license: '营业执照:',
    qualifications: '公司资质:',
    corporate_photos: '企业照片:',
    enterprise_video: '企业视频:',
    select_video: '选择视频',
    video_size_limit: '视频大小不能大于 10 M',
    submit_authenti: '提交认证',
    // 修改密码
    login_account: '登录账号:',
    message_code: '短信验证码:',
    new_password: '新密码:',
    submit: '提交',
    obtain_code: '获取验证码',
    code_cannot_empty: '短信验证码不能为空',
    new_psd_cannot_empty: '新密码不能为空',
    password_tooweak: '密码强度不够',
    second_obtain: '秒后获取',
    param_illegal: '参数不合法'
  }
}
